import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import {
  AidaPayload,
  AidaSurveyErrorDetails,
} from '../../../interfaces/aida.interface';
import {
  Qualification,
  QualificationData,
} from '../../../interfaces/qualification.interface';

export interface AidaMappedQualification {
  census: {
    enabled: boolean;
    data?: QualificationData[];
  };
  dbQualificationCode: number;
}

export interface AidaQualifications {
  [key: number]: AidaMappedQualification;
}

@Injectable({
  providedIn: 'root',
})
export class AidaPayloadService {
  constructor() {}

  private _aidaPayload$ = new BehaviorSubject<AidaPayload>({
    enabled: false,
    selected_quota_ids: [],
  });

  private _aidaLiveEditPayload$ = new BehaviorSubject<AidaPayload>({
    enabled: false,
    selected_quota_ids: [],
  });

  private _aidaSurveyErrorDetails$ = new Subject<AidaSurveyErrorDetails>();

  private _aidaError$ = new BehaviorSubject<string>('');

  private _mappedQualificationCodes: AidaQualifications = {};
  // qualification_code mapped with db_qualification_code

  private _qualifications$ = new BehaviorSubject<Qualification[]>([]); // qualifications with db_qualification_code

  public getAidaPayload() {
    return this._aidaPayload$.asObservable();
  }

  public setAidaPayload(payload: AidaPayload) {
    this._aidaPayload$.next(payload);
  }

  public getAidaError() {
    return this._aidaError$.asObservable();
  }

  public sendAidaError(message: string) {
    this._aidaError$.next(message);
  }

  public getAidaLiveEditPayload() {
    return this._aidaLiveEditPayload$.asObservable();
  }

  public sendAidaLiveEditPayload(payload: AidaPayload) {
    this._aidaLiveEditPayload$.next(payload);
  }

  public getAidaSurveyErrorDetails() {
    return this._aidaSurveyErrorDetails$.asObservable();
  }

  public sendAidaSurveyErrorDetails(error: AidaSurveyErrorDetails) {
    return this._aidaSurveyErrorDetails$.next(error);
  }

  public setQualifications(qualifications: Qualification[] = []) {
    qualifications.forEach(
      ({ qualification_code, db_qualification_code, census }) =>
        (this._mappedQualificationCodes[qualification_code] = {
          dbQualificationCode: db_qualification_code,
          census,
        })
    );

    this._qualifications$.next(qualifications);
  }

  public getQualifications() {
    return this._qualifications$.asObservable();
  }

  public getMappedDBQualificationCodes(): AidaQualifications {
    return this._mappedQualificationCodes;
  }
}
